import styled from 'styled-components';

export const StyledBackdrop = styled.div(
  ({ transition, withColor, theme: { colors } }) => ({
    background: withColor && colors.backdrop,
    bottom: 0,
    height: '100%',
    left: 0,
    opacity: (() => {
      if (transition) {
        return transition === 'entered' ? 1 : 0;
      }

      return 1;
    })(),
    position: 'fixed',
    right: 0,
    top: 0,
    transition: transition && 'opacity 0.25s ease',
    width: '100%',
    zIndex: 9997,
  }),
);
